import { useState } from 'react';
import type { GalleryPhoto } from '../types';

interface PhotoGridProps {
  photos: GalleryPhoto[];
  onPhotoClick: (index: number) => void;
}

function ImagePlaceholder() {
  return (
    <div className="flex h-full w-full items-center justify-center bg-gray-200 text-gray-400" data-testid="image-placeholder">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909M3.75 21h16.5A2.25 2.25 0 0022.5 18.75V5.25A2.25 2.25 0 0020.25 3H3.75A2.25 2.25 0 001.5 5.25v13.5A2.25 2.25 0 003.75 21z" />
      </svg>
    </div>
  );
}

export default function PhotoGrid({ photos, onPhotoClick }: PhotoGridProps) {
  const [failedImages, setFailedImages] = useState<Set<string>>(new Set());

  const handleImageError = (submissionId: string) => {
    setFailedImages((prev) => new Set(prev).add(submissionId));
  };

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      {photos.map((photo, index) => (
        <button
          key={photo.submissionId}
          type="button"
          className="group text-left"
          onClick={() => onPhotoClick(index)}
        >
          <div className="aspect-square overflow-hidden rounded-lg bg-gray-100">
            {failedImages.has(photo.submissionId) ? (
              <ImagePlaceholder />
            ) : (
              <img
                src={photo.thumbnailUrl}
                alt={photo.caption || 'Photo'}
                loading="lazy"
                className="h-full w-full object-cover transition-transform group-hover:scale-105"
                onError={() => handleImageError(photo.submissionId)}
              />
            )}
          </div>
          {photo.caption && (
            <p className="mt-1.5 text-sm text-gray-600 line-clamp-2">
              {photo.caption}
            </p>
          )}
        </button>
      ))}
    </div>
  );
}
